import * as React from 'react';
import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

function Input({
  className,
  type,
  ref,
  ...props
}: InputProps & { ref?: React.Ref<HTMLInputElement> }) {
  return (
    <input
      type={type}
      className={cn(
        'flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground',
        'placeholder:text-muted-foreground/60',
        'transition-colors',
        // Mesmo foco do ecrã de entrada (ver `authInputClass`): halo suave da cor primária.
        'focus-visible:outline-hidden focus-visible:border-primary focus-visible:ring-4 focus-visible:ring-primary/10',
        'disabled:cursor-not-allowed disabled:bg-muted/40 disabled:text-muted-foreground disabled:border-border/60',
        'read-only:bg-muted/30 read-only:text-muted-foreground',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        'touch-manipulation',
        className
      )}
      ref={ref}
      {...props}
    />
  );
}

export { Input };
